import axios from '@/lib/axios/axios';

export default {
    /**
     * A get request to the prescriptions endpoint will return a paginated list of all prescription requests
     * in the system, scoped to user.
     */
    getAllPrescriptionRequests: async () => axios.get('/prescription-requests'),

    /**
     * Posts the prescription requests to the api.
     * @param  formData
     * @returns
     */
    postPrescriptionRequest: async (formData) => axios.post('/prescription-requests', formData),

    /**
     * Returns a specified prescription request
     * @param {number || string} prescriptionId - Id of the prescription to retrieve.
     */
    getPrescriptionRequest: async (prescriptionId) => axios.get(`/prescription-requests/${prescriptionId}`),

    /**
     * Updates the delivery address on a prescription.
     * @param {string} uuid - Unique ID of the prescription to update.
     * @param {object} patchData - The data to be sent in the patch request.
     */
    updatePrescriptionRequestDeliveryAddress: async (uuid, patchData) => axios.patch(`/prescription-requests/${uuid}/delivery`, patchData),

    /**
     * Updates the GP address on a prescription.
     * @param {string} uuid - Unique ID of the prescription to update.
     * @param {object} patchData - The data to be sent in the patch request.
     */
    updatePrescriptionRequestGpAddress: async (uuid, patchData) => axios.patch(`/prescription-requests/${uuid}/gp`, patchData),
};
